import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { IonPopover, ModalController } from '@ionic/angular';
import { Store } from '@ngrx/store';
import { Training } from '../../domains/training/training/training.model';
import { handleDatePickerDismiss } from '../../shared/utils/date-picker-popover';
import { claimDateChosen, claimTrainingCancelled, trainingClaiming } from './claim-training-modal.actions';
import { claimTrainingContext } from './claim-training-modal.selectors';

@Component({
  selector: 'gc-claim-training-modal',
  templateUrl: './claim-training-modal.component.html',
  styleUrls: ['./claim-training-modal.component.scss'],
})
export class ClaimTrainingModalComponent {
  context$ = this.store.select(claimTrainingContext);
  claimDateControl = new FormControl<Date | null>(null);

  constructor(
    public readonly modalGC: ModalController,
    private readonly store: Store,
  ) {}

  async addTraining(popoverGC: IonPopover) {
    const date = this.claimDateControl.value;
    if (!date) {
      return;
    }

    await popoverGC.dismiss(undefined, 'ok');
    this.store.dispatch(claimDateChosen({ date: new Date(date).toISOString() }));
  }

  adding(training: Training): void {
    this.store.dispatch(trainingClaiming({ training }));
    this.claimDateControl.setValue(null);
  }

  openDatePicker(
    popoverGC: IonPopover,
    event: {
      $event: MouseEvent | TouchEvent | PointerEvent | CustomEvent;
      value: Training;
    },
  ): void {
    this.adding(event.value);
    popoverGC.present(event.$event);
  }

  onDatePickerDismiss(popoverGC: IonPopover, status: 'cancel' | 'confirm'): void {
    handleDatePickerDismiss(popoverGC, status, () => this.addTraining(popoverGC));
  }

  cancelled(event: any): void {
    if (event.detail.role === 'backdrop' || event.detail.role === 'cancel') {
      this.store.dispatch(claimTrainingCancelled());
    }
  }
}
